export const route = {
  home: "/",
  login: "/",
  dashboard: "/dashboard",
  items: "/items",
  processes: "/processes",
  processDefinitions: "/process-definitions",
  parties: "/parties",
  partiesView: "/parties/:id/view",
  partiesRates: "/parties/:id/rates",
  processDefinitionRates: "/process-definitions/:id/rates",
  payments: "/payments/:id",
  users: "/users",
  usersCreate: "/users/create",
  usersEdit: "/users/:id/edit",
  accountTypes: "/account-types",
  accounts: "/accounts",
  materials: "/materials",
  itemSizes: "/item-sizes",
  processOrders: "/process-orders",
  processOrdersCreate: "/process-orders/create",
  processOrdersEdit: "/process-orders/:id/edit",
  processOrdersView: "/process-orders/:id/view",
  processReceives: "/process-receives",
  processReceivesCreate: "/process-receives/create",
  processReceivesEdit: "/process-receives/:id/edit",
  processReceivesView: "/process-receives/:id/view",
  activityLogs: "/activity-logs",
  devFeedback: "/dev-feedback",
  profile: "/profile",
  settings: "/settings",
  stockSizes: "/stock/sizes",
  stockPieces: "/stock/pieces",
  stockProcessItems: "/stock/process-items",
  stockProcessParties: "/stock/process-parties",
};
